import { Injectable } from '@angular/core';
import {RestService} from "../rest.service";
import {Observable} from "rxjs";
import {IRsvpDetails} from "../../models/rsvp.models";
import {environment} from "../../../../environments/environment";
import {HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RsvpService {
  private readonly baseUrl: string;

  constructor(private readonly restService: RestService) {
    this.baseUrl = environment.apiURL;
  }

  public listRsvpStatusForType(hostUserId: number, customId: string): Observable<IRsvpDetails[]> {
    return this.restService.get<IRsvpDetails[]>({
      url: `${this.baseUrl}/api/rsvp/${customId}/${hostUserId}`,
      headers: new HttpHeaders()
    });
  }
}
